import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Avatar,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Close as CloseIcon,
  Settings as SettingIcon,
  Logout,
} from "@mui/icons-material";
import {
  primary,
  secondary,
  lightBg,
  textsecondary,
} from "../constants/colors";
import Logo from "../assets/logo_2.svg";
import Person from "../assets/Person.svg";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import AddCardRoundedIcon from '@mui/icons-material/AddCardRounded';
import DevicesOtherOutlinedIcon from "@mui/icons-material/DevicesOtherOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import PersonalInjuryOutlinedIcon from "@mui/icons-material/PersonalInjuryOutlined";
import {
  AdminIcon,
  FacilityIcon,
  FeedbackIcon,
  FileIcon,
  ReportIcon,
  Stethoscope,
} from "../components/Icons";

export default function AdminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    userData,
    isMobile,
    drawerOpen,
    setDrawerOpen,
    guardedNavigate,
  } = useAppContext();

  const [profilePicture, setProfilePicture] = useState(null);
  const [userName, setUserName] = useState("John Doe");

  useEffect(() => {
    setUserName(userData.fullName);
    if (userData.User_Photo_Path !== null && userData.User_Photo_Path !== "") {
      setProfilePicture(userData.User_Photo_Path);
    } else {
      setProfilePicture(Person);
    }
  }, [userData]);

  const menuItems = [
    {
      link: "/admin/dashboard",
      icon: <DashboardOutlinedIcon sx={{ fontSize: "20px" }} />,
      text: "Dashboard",
      // count: 2,
    },
    {
      link: "/admin/submitted-forms",
      icon: <FileIcon sx={{ fontSize: "20px" }} />,
      text: "Submitted Forms",
    },
    {
      link: "/admin/test",
      icon: <ReportIcon sx={{ fontSize: "20px" }} />,
      text: "Test Requests",
    },
    {
      link: "/admin/examination",
      icon: <FileIcon sx={{ fontSize: "20px" }} />,
      text: "Request Provider Visit",
    },
    {
      link: "/admin/patients",
      icon: <PersonalInjuryOutlinedIcon sx={{ fontSize: "20px" }} />,
      text: "Patients",
    }, 
    {
      link: "/admin/user-feedback",
      icon: <FeedbackIcon sx={{ fontSize: "20px" }} />,
      text: "Help",
    },
    {
      link: "/admin/contacts",
      icon: <FileIcon sx={{ fontSize: "20px" }} />,
      text: "Contacts Form",
    },
    {
      link: "/admin/payments",
      icon: <AddCardRoundedIcon sx={{ fontSize: "20px" }} />,
      text: "Payment Received",
    },
    {
      link: "/admin/newsletter",
      icon: <NewspaperOutlinedIcon sx={{ fontSize: "20px" }} />,
      text: "Newsletter Signup",
    },
    {
      link: "/admin/physicians",
      icon: <Stethoscope />,
      text: "Physicians",
    },
    {
      link: "/admin/facility",
      icon: <FacilityIcon />,
      text: "Facilities",
    },
    {
      link: "/admin/devices",
      icon: <DevicesOtherOutlinedIcon sx={{ fontSize: "20px" }} />,
      text: "Examination Devices",
    },
    {
      link: "/admin/mobile-labs",
      icon: <BiotechOutlinedIcon sx={{ fontSize: "20px" }} />,
      text: "Mobile Labs",
    },
    {
      link: "/admin/admin",
      icon: <AdminIcon sx={{ fontSize: "20px" }} />,
      text: "Admin",
    },
    {
      link: "/admin/users",
      icon: <GroupOutlinedIcon sx={{ fontSize: "20px" }} />,
      text: "Patient Management",
    },
    // {
    //     link: "/admin/terms-conditions",
    //     icon: <TermsIcon sx={{ fontSize: "20px" }} />,
    //     text: "Terms & Conditions",
    // },

    // {
    //   link: "/admin/privacy-policy",
    //   icon: <PrivacyIcon sx={{ fontSize: "20px" }} />,
    //   text: "Privacy Policy",
    // },
  ];

  const sidebarContent = (
    <Box
      sx={{
        width: { xs: "100vw", sm: 280 },
        height: "100vh",
        backgroundColor: "#ffffff",
        // borderRight: { sm: "1px solid #333" },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box
          display="flex"
          // justifyContent={isMobile ? "space-between" : "center"}
          justifyContent="space-between"
          alignItems="center"
        >
          <img src={Logo} width={"180px"} alt="Logo" />
          {isMobile && (
            <IconButton
              onClick={() => setDrawerOpen(false)}
              sx={{ color: "#999" }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Box>

      <Box sx={{ flex: 1, paddingX: 2 }}>
        <Box
          sx={{
            px: 2,
            mb: 2,
            backgroundColor: "#F5F5FF",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            padding: "8px",
            gap: 1,
          }}
        >
          <Avatar
            sx={{
              width: 40,
              height: 40,
            }}
            src={profilePicture}
          />
          <Box>
            <Typography
              fontSize={"20px"}
              className="sf-medium"
              sx={{
                textTransform: "capitalize",
                color: "#7B7DE5 !important",
                lineHeight: "22px",
              }}
            >
              {userName !== null ? userName.split(" ")[0] : "User"}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              fontSize={"12px"}
            >
              Admin
            </Typography>
          </Box>
        </Box>
        <p style={{ marginBottom: 3 }}>Menu</p>
        <List
          sx={{
            overflowY: "auto",
            maxHeight: "calc(100vh - 260px)",
            paddingRight: 0.6,
          }}
          className="light-scrollbar"
        >
          {menuItems.map((item, index) => (
            <ListItem
              key={index}
              onClick={() => {
                setDrawerOpen(false);
                guardedNavigate(navigate, item.link);
              }}
              className="class-for-icon"
              sx={{
                cursor: "pointer",
                borderRadius: "8px",
                marginBottom: 0.5,
                alignItems: "center",
                backgroundColor: location.pathname.includes(item.link)
                  ? "#F5F5FF"
                  : "transparent",
                color: location.pathname.includes(item.link)
                  ? primary
                  : textsecondary,
                ".MuiListItemIcon-root": {
                  color: location.pathname.includes(item.link)
                    ? primary
                    : textsecondary,
                },

                "&:hover": {
                  backgroundColor: primary,
                  color: secondary,
                },

                "&:hover .MuiListItemIcon-root": {
                  color: secondary,
                },

                "&:hover .notification-badge": {
                  backgroundColor: '#ffffff',
                  color: 'primary.main',
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>{item.icon}</ListItemIcon>

              <ListItemText
                primary={item.text}
                typographyprops={{
                  fontSize: "0.9rem",
                  marginBottom: 0,
                }}
              />
              {item.count > 0 && (
                <Box
                  className="notification-badge"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "#ffffff",
                    position: "absolute",
                    right: '10px',
                    top: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    fontSize: "12px",
                    fontWeight: 500,
                  }}
                >
                  {item.count}
                </Box>
              )}
            </ListItem>
          ))}
        </List>
      </Box>

      <Box sx={{ paddingX: 2, paddingY: 1 }}>
        {/* <Button onClick={() => setShowBookingModal(true)}>Book</Button> */}
        {/* <Box
              // onClick={(e) => setProfileMenuAnchor(e.currentTarget)}
              onClick={(e) => {
                setDrawerOpen(false);
                navigate("/profile");
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                p: 1,
                borderRadius: "8px",
                cursor: "pointer",
                "&:hover": { backgroundColor: primary, color: secondary },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: primary,
                    fontSize: "0.875rem",
                    marginRight: "10px",
                  }}
                >
                  <img src={profilePicture} width={32} height={32} />
                </Avatar>
                <Typography variant="body2" className="sf-regular">
                  {userName !== null ? userName : ""}
                </Typography>
              </Box>
    
              <SettingIcon />
            </Box> */}
        <Box
          onClick={(e) => {
            setDrawerOpen(false);
            guardedNavigate(navigate, "/admin/profile");
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 1,
            p: 1,
            borderRadius: "8px",
            cursor: "pointer",
            mb: 0.2,
            color: primary,
            "&:hover": { backgroundColor: primary, color: secondary },
          }}
        >
          <SettingIcon sx={{ fontSize: "20px" }} />
          <Typography variant="body2" className="sf-regular" fontSize={"16px"}>
            Account Settings
          </Typography>
        </Box>
        <Box
          onClick={(e) => {
            localStorage.clear();
            guardedNavigate(navigate, "/login");
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 1,
            p: 1,
            borderRadius: "8px",
            cursor: "pointer",
            color: primary,
            "&:hover": { backgroundColor: primary, color: secondary },
          }}
        >
          <Logout sx={{ fontSize: "20px" }} />
          <Typography variant="body2" className="sf-regular" fontSize={"16px"}>
            Logout
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      {isMobile ? (
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { backgroundColor: "transparent", boxShadow: "none" },
          }}
        >
          {sidebarContent}
        </Drawer>
      ) : (
        <Paper
          elevation={0}
          sx={{
            width: 280,
            backgroundColor: lightBg,
            borderRadius: 0,
            position: "fixed",
            top: 0,
          }}
        >
          {sidebarContent}
        </Paper>
      )}
      {/* <AppointmentBooking
        open={showBookingModal}
        handleClose={() => setShowBookingModal(false)}
      /> */}
    </>
  );
}
